import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { ProjectDataForm, Product, ProjectUserOption } from '../../../app/models/Project';
import { CostCenterDataForm } from '../../../app/models/CostCenter';
import ProjectForm from './forms/ProjectForm';

interface Props {
  fetching?: boolean;
  action: () => void;
  cancel: () => void;
  project: ProjectDataForm;
  setProject: (data: ProjectDataForm) => void;
  products: Product[];
  users?: ProjectUserOption[];
  costCenters?: CostCenterDataForm[];
  errorFields?: any;
}

const ProjectFormContainer = ({
  fetching,
  action,
  cancel,
  project,
  setProject,
  products,
  users = [],
  costCenters = [],
  errorFields = null
}: Props) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <ProjectForm
            projectDataForm={project}
            setProjectDataForm={setProject}
            products={products}
            users={users}
            costCenters={costCenters}
            errorFields={errorFields}
          />
        </div>
      </div>
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={action} locked={fetching} />
        </div>
      </div>
    </>
  );
};

export default ProjectFormContainer;